/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable @nx/enforce-module-boundaries */
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators';
import $http from '../services/api';

import { IRegisterTan, CreateRegisterTanDto } from '@license-manager/types';
import { runInThisContext } from 'vm';

@Module({ namespaced: true })
export default class RegisterTan extends VuexModule {
  registerWithCount: [IRegisterTan[], number] = [[], 0];
  isLoading = false;

  private urlPrefix = 'registertan';

  @Mutation
  setLoading(loadingState = false) {
    this.isLoading = loadingState;
  }

  @Mutation
  setRegisterWithCount(data: [IRegisterTan[], number]) {
    this.registerWithCount = data;
  }

  @Action({ rawError: true })
  async updateOrGenerateTan(payload: {
    id?: number;
    tan: CreateRegisterTanDto;
  }) {
    this.context.commit('setLoading', true);

    try {
      if (payload.id) {
        const resp = await $http.put(
          this.urlPrefix + '/' + payload.id,
          payload.tan
        );
      } else {
        const resp = await $http.post(this.urlPrefix + '/', payload.tan);
      }
    } finally {
      this.context.commit('setLoading', false);
    }
  }

  @Action
  async loadRegisterTans({
    take = 100,
    skip = 0,
    like = null,
    appRoleId = null,
    customerId = null,
    claimed = undefined,
  }: {
    take?: number;
    skip?: number;
    like?: string;
    appRoleId?: string;
    customerId?: number;
    claimed?: boolean;
  }) {
    this.context.commit('setLoading', true);

    const registertanwithcount = await $http
      .get(this.urlPrefix, {
        params: { take, skip, like, appRoleId, customerId, claimed },
      })
      .then((response) => response.data);
    this.context.commit('setLoading', false);
    this.context.commit('setRegisterWithCount', registertanwithcount);
  }

  get registerTan(): IRegisterTan[] {
    return this.registerWithCount[0];
  }

  get totalCount(): number {
    return this.registerWithCount[1];
  }
}
